import { APPROVE_PAID_UP_CAPITAL, GET_PAID_UP_CAPITAL, GET_PAYMENTS } from "../actions/types";
const initialState = {
  payments: [],
  paidUpCapitalList: [],
  paidUpCapitalCount: 0,
  paidUpCapitalTotal: 0,
  paidUpCapitalApproval: null,
};
export default function (state = initialState, action) {
  const { type, payload, page, count, total } = action;
  switch (type) {
    case GET_PAYMENTS:
      // var data = [];
      // if(page===1){
      //   data = [...payload]
      // }else{
      //   if(payload.length>0){
      //     data = [...state.payments, ...payload]
      //   }else{
      //     data = [...state.payments]
      //   }
      // }
      return {
        ...state,
        payments: payload,
        count: count
      };
    case APPROVE_PAID_UP_CAPITAL:
      return {
        ...state,
        paidUpCapitalApproval: payload,
      };
    case GET_PAID_UP_CAPITAL:
      return {
        ...state,
        paidUpCapitalList: payload,
        paidUpCapitalCount: count,
        paidUpCapitalTotal: total,
      };
    default:
      return state;
  }
}
